import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Form, FormCreatorService, LoadingPanelService, LocalService } from 'lib-base';
import { MessageService } from 'primeng/api';
import { FormularioService } from '../../../services/formulario.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormViewerComponent } from '../../../components/form-viewer/form-viewer.component';
import { firstValueFrom, forkJoin } from 'rxjs';
import { CreateTramiteRegistroRequest } from '../../../shared/interfaces/liquidacion';
import { TramRegistroSolicitudService } from '../../../services/tramiteRegistroSolicitud.service';
import { PortalUsuarioService } from '../../../services/portalUsuario.service';
import { IGetInformacionUsuarioFormulario } from '../../../shared/interfaces/seguridad';
import { ProcesarTramiteComponent } from '../procesar-tramite/procesar-tramite.component';

@Component({
  selector: 'app-create-tramite',
  standalone: true,
  imports: [
    CommonModule, TranslateModule, ProcesarTramiteComponent,
    FormViewerComponent,
  ],
  providers: [FormCreatorService],
  templateUrl: './create-tramite.component.html'
})
export class CreateTramiteComponent implements OnInit {
  private _dependenciaId !: number;
  private _tramiteId !: number;
  private _empresaId?: number;
  private _translations: any = {};

  @ViewChild(ProcesarTramiteComponent) _procesarTramite !: ProcesarTramiteComponent;
  @ViewChild(FormViewerComponent) _formViewerComponent !: FormViewerComponent;

  constructor(
    public readonly fc: FormCreatorService, private readonly _fs: FormularioService, private readonly _trs: TramRegistroSolicitudService, private readonly _ls: LocalService,
    private readonly route: ActivatedRoute, public messageService: MessageService, private readonly _t: TranslateService, private readonly _router: Router, private readonly _lps: LoadingPanelService,
    private readonly _pu: PortalUsuarioService
  ) {
    this.onSubmitForm = this.onSubmitForm.bind(this);
    const options = {
      isDesigner: false,
      enableSubmit: true
    }
    this.fc.setOptions(options);
  }

  ngOnInit() {
    this._dependenciaId = Number(this.route.snapshot.params['dependenciaId']);
    this._tramiteId = Number(this.route.snapshot.params['tramiteId']);
    this._empresaId = Number(this.route.snapshot.params['empresaId']);

    this.translate();

    this.getFormulario();
    this.getUserData();
  }

  private async translate(): Promise<void>{
    this._translations = await firstValueFrom(forkJoin({
      aceptar: this._t.get('form.button.aceptar'),
      cargando: this._t.get('msg.cargando'),
      tramiteCreado: this._t.get('components.app-create-tramite.tramite-creado'),
      tramiteInactivo: this._t.get('msg.tramiteInactivo'),
    }));
  }

  getFormulario() {
    if (!this._tramiteId && this._dependenciaId) return;
    this._fs.getFormularioByTipoTramiteId(this._dependenciaId, this._tramiteId).subscribe({
      next: (response: Form) => {
        this._procesarTramite.requierePago = response.requierepago;
        this._procesarTramite.fuentePago = response.fuentedepago;
        if(response.requierepago && !response.costovigente){
          this.messageService.add({ severity: 'error', summary: 'Failed to load', detail: this._translations.tramiteInactivo });
          this._router.navigate(['/public/consulta']);
          return
        }
        this.fc.loadForm(response);
        this.fc.Form.title = response.nombre;
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Failed to load', detail: error.message });
      }
    });
  }

  getUserData() {
    this._pu.getInformacionUsuarioFormulario().subscribe({
      next: (response: IGetInformacionUsuarioFormulario) => {
        this.fc.userData = response;
      },
    });
  }

  onSubmitForm(data: string) {
    let newTramite = {
      tipoTramiteId: this._tramiteId,
      dependenciaId: this._dependenciaId,
      portalUsuarioEmpresaId: this._empresaId,
      respuesta: data
    } as CreateTramiteRegistroRequest

    this._lps.show();

    this._trs.createTramiteSolicitud(newTramite).subscribe({
      next: (tramRegistroSolicitudId:number) => {
        this._lps.hide();
        this._procesarTramite.showEnviarTokenFirmaElectronica(tramRegistroSolicitudId);
      },error: (error) => {
        this._lps.hide();
      }
    });
  }
}
